import React, { useRef, useState } from "react";
import Axios from "axios";
// import { toast, ToastContainer } from "react-toastify";

const ALLOWED_IMAGE_TYPES = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/webp",
];
const MAX_IMAGE_SIZE = 500 * 1024; // 500 KB
const MIN_REVIEW_LENGTH = 50;
const MAX_REVIEW_LENGTH = 600;
const MAX_NAME_LENGTH = 30;

const UserReviewForm = () => {
  // ── Fields match `user_review_requests` columns ──
  const [reviewerName, setReviewerName] = useState("");
  const [rating, setRating] = useState(0);
  const [reviewText, setReviewText] = useState("");
  const [reviewerImage, setReviewerImage] = useState(null);

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);
  const [submitted, setSubmitted] = useState(false);
  const [consentChecked, setConsentChecked] = useState(false);

  const clearFieldError = (field) => {
    setErrors((prev) => {
      if (!prev[field]) return prev;
      const next = { ...prev };
      delete next[field];
      return next;
    });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!reviewerName.trim()) {
      newErrors.reviewerName = "Full name is required.";
    } else if (reviewerName.trim().length < 2) {
      newErrors.reviewerName = "Full name must be at least 2 characters.";
    } else if (reviewerName.trim().length > MAX_NAME_LENGTH) {
      newErrors.reviewerName = `Reviewer name cannot exceed ${MAX_NAME_LENGTH} characters.`;
    }

    if (!rating || rating < 1 || rating > 5) {
      newErrors.rating = "Please select a rating.";
    }

    if (!reviewText.trim()) {
      newErrors.reviewText = "Please share your experience.";
    } else if (reviewText.trim().length < MIN_REVIEW_LENGTH) {
      newErrors.reviewText = `Please write at least ${MIN_REVIEW_LENGTH} characters.`;
    } else if (reviewText.length > MAX_REVIEW_LENGTH) {
      newErrors.reviewText = `Review cannot exceed ${MAX_REVIEW_LENGTH} characters.`;
    }

    if (!reviewerImage) {
      newErrors.reviewerImage = "Please upload your photo.";
    } else if (!ALLOWED_IMAGE_TYPES.includes(reviewerImage.type)) {
      newErrors.reviewerImage = "Only PNG, JPG, JPEG & WEBP files are allowed.";
    } else if (reviewerImage.size > MAX_IMAGE_SIZE) {
      newErrors.reviewerImage = "Image size must be less than 500 KB.";
    }

    if (!consentChecked) {
      newErrors.consent = "Please accept the consent statement.";
    }

    setErrors(newErrors);

    if (newErrors.consent) {
      // toast.error(newErrors.consent);
    }

    return Object.keys(newErrors).length === 0;
  };

  const clearForm = () => {
    setReviewerName("");
    setRating(0);
    setReviewText("");
    setReviewerImage(null);
    setConsentChecked(false);
    setErrors({});

    const fileInput = document.getElementById("reviewerImage");
    if (fileInput) {
      fileInput.value = "";
    }
  };

  const submitReview = async () => {
    if (!validateForm()) {
      // toast.error("Please fix the highlighted fields.");
      return;
    }

    try {
      setLoading(true);

      const formData = new FormData();

      formData.append("reviewer_name", reviewerName);
      formData.append("rating", rating);
      formData.append("review_text", reviewText);
      formData.append("reviewer_image", reviewerImage);

      const res = await Axios.post(
        `${process.env.REACT_APP_API_BASE_URL}php/submit_review.php`,
        formData,
      );

      if (res.data.success) {
        clearForm();
        setSubmitted(true);
      } else {
        // toast.error(res.data.message);
      }
    } catch (err) {
      console.log(err);
      // toast.error("Submission failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{`
body{
    background:#f4f7fb;
}

.primary-btn {
  color: #fff;
  background-color: #009bd4;
  border-color: #009bd4;
}
.primary-btn:hover {
  color: #fff;
  background-color: #17171d;
  border-color: #17171d;
}

.ctf-page{
    min-height:100vh;
    display:flex;
    justify-content:center;
    align-items:center;
    padding:40px 12px;
    background:#f4f7fb;
    overflow-y:auto;
}

.ctf-card{
    width:100%;
    max-width:460px;
    background:#fff;
    border-radius:18px;
    overflow:hidden;
    box-shadow:0 10px 30px rgba(15,23,42,.08);
}

.ctf-header{
    padding:22px 20px 14px;
    text-align:center;
    border-bottom:1px solid #edf1f6;
}

.ctf-company-logo{
    width:90px;
    margin:auto;
    display:block;
    margin-bottom:12px;
}

.ctf-title{
    font-size:19px;
    font-weight:700;
    color:#1d3557;
    margin:0;
}

.ctf-form{
    padding:18px 20px 24px;
}

.ctf-field{
    display:flex;
    flex-direction:column;
    margin-bottom:16px;
}

.ctf-field label{
    font-weight:600;
    color:#26364d;
    margin-bottom:6px;
    font-size:13px;
}

.form-control{
    height: 30px !important;
}

.ctf-field .form-control{
    border-radius:10px;
    border:1px solid #d9e2ec;
    min-height:44px;
    padding:10px 14px;
    font-size:14.5px;
    transition:.2s;
    box-shadow:none;
}

.ctf-field textarea.form-control{
    min-height:110px;
    resize:vertical;
}

.ctf-field .form-control:focus{
    border-color:#009BD4;
    box-shadow:0 0 0 3px rgba(0,155,212,.12);
}

.ctf-field .form-control.is-invalid{
    border-color:#dc3545;
}

.ctf-error{
    color:#dc3545;
    font-size:12px;
    margin-top:4px;
    line-height:1.4;
}

.ctf-star-picker{
    display:flex;
    gap:6px;
    align-items:center;
}

.ctf-star-picker button{
    background:none;
    border:none;
    padding:0;
    font-size:28px;
    line-height:1;
    cursor:pointer;
    color:#dcdfe3;
    transition:.15s;
}

.ctf-star-picker button.is-filled{
    color:#f5a623;
}

.ctf-char-count{
    text-align:right;
    margin-top:4px;
    font-size:12px;
    color:#9aa6b2;
}

.ctf-photo-row{
    display:flex;
    align-items:center;
    gap:12px;
}

.ctf-photo-avatar{
    width:52px;
    height:52px;
    border-radius:50%;
    object-fit:cover;
    border:1px solid #dbe4ee;
    flex:none;
}

.ctf-photo-btn{
    border:1px solid #d9e2ec;
    background:#f8fbff;
    color:#009BD4;
    border-radius:10px;
    padding:10px 14px;
    font-size:13.5px;
    font-weight:600;
    cursor:pointer;
    display:flex;
    align-items:center;
    gap:8px;
    flex:1;
}

.ctf-photo-btn:hover{
    background:#eef7fc;
}

.ctf-photo-btn.is-invalid{
    border-color:#dc3545;
    color:#dc3545;
}

.ctf-upload-note{
    color:#8a97a6;
    font-size:11.5px;
    margin-top:6px;
}

.ctf-consent-box{
    background:#f8fafc;
    border:1px solid #e5edf6;
    border-radius:10px;
    padding:14px;
    color:#5b6778;
    line-height:1.5;
    font-size:12.5px;
    margin-bottom:16px;
}

.ctf-consent-row{
    display:flex;
    align-items:flex-start;
    margin-top:10px;
    gap:8px;
}

.ctf-consent-row label{
    margin:0;
    cursor:pointer;
    color:#1f2937;
    font-weight:500;
    font-size:12.5px;
}

.ctf-required{
    color:#dc3545;
}

.ctf-submit button{
    width:100%;
    height:48px;
    border:none;
    border-radius:12px;
    font-size:15.5px;
    font-weight:700;
}

.ctf-thankyou{
    text-align:center;
    padding:36px 20px 44px;
}

.ctf-thankyou i{
    font-size:48px;
    color:#198754;
    margin-bottom:14px;
}

.ctf-thankyou h2{
    font-weight:700;
    font-size:17px;
    margin-bottom:10px;
}

.ctf-thankyou p{
    color:#6c757d;
    line-height:1.6;
    font-size:13.5px;
    margin:0;
}

`}</style>

      <div className="ctf-page">
        <div className="ctf-card">
          {submitted ? (
            <>
              <div className="ctf-header">
                <img
                  src="/images/ange_gulf_logo.png"
                  alt="Angel Gulf Jobs"
                  className="ctf-company-logo"
                />
              </div>

              <div className="ctf-thankyou">
                <h1 className="ctf-title mb-0">Thanks for your feedback!</h1>
                {/* <i className="fa fa-check-circle"></i>
                <h2>Review submitted</h2>
                <p>Your review will appear on our site once it's approved.</p> */}
              </div>
            </>
          ) : (
            <>
              <div className="ctf-header">
                <img
                  src="/images/ange_gulf_logo.png"
                  alt="Angel Gulf Jobs"
                  className="ctf-company-logo"
                />
                <h1 className="ctf-title">Share Your Experience</h1>
              </div>

              <div className="ctf-form" ref={formRef}>
                {/* Name */}
                <div className="ctf-field">
                  <label>
                    Full Name <span className="ctf-required">*</span>
                  </label>
                  <input
                    type="text"
                    maxLength={MAX_NAME_LENGTH}
                    className={`form-control ${errors.reviewerName ? "is-invalid" : ""}`}
                    placeholder="Your full name"
                    value={reviewerName}
                    onChange={(e) => {
                      setReviewerName(e.target.value);
                      clearFieldError("reviewerName");
                    }}
                  />
                  {errors.reviewerName && (
                    <div className="ctf-error">{errors.reviewerName}</div>
                  )}
                </div>

                {/* Photo — right under name, preview shown only once selected */}
                <div className="ctf-field">
                  <label>
                    Your Photo <span className="ctf-required">*</span>
                  </label>

                  <div className="ctf-photo-row">
                    {reviewerImage && (
                      <img
                        src={URL.createObjectURL(reviewerImage)}
                        alt="Preview"
                        className="ctf-photo-avatar"
                      />
                    )}

                    <label
                      htmlFor="reviewerImage"
                      className={`ctf-photo-btn ${errors.reviewerImage ? "is-invalid" : ""}`}
                    >
                      <i className="fa fa-camera"></i>
                      {reviewerImage ? "Change Photo" : "Upload Photo"}
                    </label>

                    <input
                      id="reviewerImage"
                      type="file"
                      hidden
                      accept=".png,.jpg,.jpeg,.webp"
                      onChange={(e) => {
                        if (e.target.files.length > 0) {
                          setReviewerImage(e.target.files[0]);
                          clearFieldError("reviewerImage");
                        }
                      }}
                    />
                  </div>

                  <div className="ctf-upload-note">
                    PNG, JPG or WEBP, max 500 KB
                  </div>

                  {errors.reviewerImage && (
                    <div className="ctf-error">{errors.reviewerImage}</div>
                  )}
                </div>

                {/* Rating */}
                <div className="ctf-field">
                  <label>
                    Your Rating <span className="ctf-required">*</span>
                  </label>

                  <div className="ctf-star-picker">
                    {[1, 2, 3, 4, 5].map((n) => (
                      <button
                        key={n}
                        type="button"
                        className={n <= rating ? "is-filled" : ""}
                        onClick={() => {
                          setRating(n);
                          clearFieldError("rating");
                        }}
                        aria-label={`${n} star`}
                      >
                        ★
                      </button>
                    ))}
                  </div>
                  {errors.rating && (
                    <div className="ctf-error">{errors.rating}</div>
                  )}
                </div>

                {/* Review */}
                <div className="ctf-field">
                  <label>
                    Your Review <span className="ctf-required">*</span>
                  </label>

                  <textarea
                    className={`form-control ${errors.reviewText ? "is-invalid" : ""}`}
                    rows="5"
                    maxLength={MAX_REVIEW_LENGTH}
                    placeholder="What was your experience like?"
                    value={reviewText}
                    onChange={(e) => {
                      setReviewText(e.target.value);
                      clearFieldError("reviewText");
                    }}
                  />

                  <div className="ctf-char-count">
                    {reviewText.length} / {MAX_REVIEW_LENGTH}
                  </div>

                  {errors.reviewText && (
                    <div className="ctf-error">{errors.reviewText}</div>
                  )}
                </div>

                {/* Consent */}
                <div className="ctf-consent-box">
                  Your review may be published on our website and social media,
                  once approved.
                  <div className="ctf-consent-row">
                    <input
                      type="checkbox"
                      id="consentCheckbox"
                      checked={consentChecked}
                      onChange={(e) => setConsentChecked(e.target.checked)}
                      style={{ marginTop: "3px", cursor: "pointer" }}
                    />
                    <label htmlFor="consentCheckbox">
                      I agree to the above.
                      <span className="ctf-required"> *</span>
                    </label>
                  </div>
                  {errors.consent && (
                    <div className="ctf-error" style={{ marginLeft: "22px" }}>
                      {errors.consent}
                    </div>
                  )}
                </div>

                <div className="ctf-submit">
                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={loading}
                    onClick={submitReview}
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                        ></span>
                        Submitting...
                      </>
                    ) : (
                      <>
                        <i className="fa fa-paper-plane me-2"></i>
                        Submit Review
                      </>
                    )}
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {/* <ToastContainer position="bottom-center" autoClose={3000} /> */}
    </>
  );
};

export default UserReviewForm;
